<template>
  <section>
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="10000"
      multi-line
      left
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>

    <!-- DIALOGS START -->
    
    <!-- DELETE VOTER -->
    <v-dialog
      v-model="dialog.deleteRole"
      max-width="500"
      persistent
      v-if="dialog.hasLoaded"
    >
      <v-card>
        <v-card-title class="headline">You Sure, about remove this role from User?</v-card-title>

        <v-card-text>
          Are you sure, you want to remove this role from User? <br/> We suggest verifying the details before taking such an action.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            flat="flat"
            @click="() => {
              dialog.deleteRole = false;
              deleteRoleId = '';
            }"
          >
            Don't Remove
          </v-btn>

          <v-btn
            color="error"
            flat="flat"
            @click="() => {
              deleteRole(deleteRoleId);
              deleteRoleId = '';
              dialog.deleteRole = false;
            }"
          >
            Remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DELETE ROLE ENDs -->

    <v-dialog
      v-model="dialog.delete"
      max-width="500"
      persistent
      v-if="dialog.hasLoaded"
    >
      <v-card>
        <v-card-title class="headline">You Sure, about deleting this User Account?</v-card-title>

        <v-card-text>
          Are you sure, you want to delete this account? <br/> We suggest verifying the details before taking such an action.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            flat="flat"
            @click="() => {
              this.$router.push('/user-accounts/' + this.$route.params.id)
              dialog.delete = false;
            }"
          >
            Don't Delete
          </v-btn>

          <v-btn
            color="error"
            flat="flat"
            @click="deleteUser"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog
      v-model="dialog.update"
      max-width="500"
      persistent
      v-if="dialog.hasLoaded"
    >
      <v-card>
        <v-card-title class="headline">Update this Account!</v-card-title>

        <v-card-text>
          <v-form v-model="valid">
            <v-text-field
              v-model="form.name"
              label="Name"
              :rules="userNameRules"
            ></v-text-field>
            <v-text-field
              v-model="form.email"
              label="E-mail"
              :rules="emailRules"
            ></v-text-field>

            <v-autocomplete
              :loading="autocompleteLoading"
              :items="companies"
              item-value="text"
              flat
              label="COMPANY"
              :rules="companyRules"
              v-model="form.company"
              :search-input.sync="search"
              clearable
              persistent-hint
              allow-overflow
              return-object
            />
            <v-text-field v-model="form.phone" label="Phone"></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            flat="flat"
            @click="() => {
              this.$router.push('/user-accounts/' + this.$route.params.id)
              dialog.update = false;
            }"
          >
            Don't Update
          </v-btn>

          <v-btn
            color="error"
            flat="flat"
            :disabled="!valid"
            @click="updateUser"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog.addRole"
      max-width="500"
      persistent
      v-if="dialog.hasLoaded"
    >
      <v-card>
        <v-card-title class="headline">Give this account a Role!</v-card-title>

        <v-card-text>
          <v-form v-model="valid">
            <v-autocomplete
              :loading="autocompleteLoading"
              :items="allRoles"
              item-text="name"
              flat
              label="ROLE"
              :rules="roleRules"
              v-model="giveRoles"
              :search-input.sync="search_role"
              clearable
              persistent-hint
              allow-overflow
              return-object
              multiple
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            flat="flat"
            @click="dialog.addRole = false"
          >
            Don't Update
          </v-btn>

          <v-btn
            color="error"
            flat="flat"
            :disabled="!valid"
            @click="giveUserAccessToRole"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog.loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOGS END -->
    <v-container grid-list-md v-if="dialog.hasLoaded && !error">
      <v-layout row wrap>
        <v-flex sm12 md2 lg2>
          <v-card class="acc--view-card" style="min-height:215px; max-height: 215px; padding: 0em;">
              <v-avatar :size="150" id="user-avatar">
                <img :src="user.avatar || 'https://lh4.googleusercontent.com/-03EW-FpeRBE/AAAAAAAAAAI/AAAAAAAAAAA/ZYNO4RH0oOo/s228-p/photo.jpg'" :alt="user.name">
              </v-avatar>
          </v-card>
        </v-flex>
        <v-flex sm12 md10 lg10>
          <v-card class="acc--view-card" style="min-height:215px;">
            <p class="acc--view-title">BASICS</p>
            <div>
              <v-btn color="info" @click="moveTo(`/user-accounts/${user.id}?update=1`)">Update Account</v-btn>
              <v-btn color="error" @click="moveTo(`/user-accounts/${user.id}?delete=1`)">Delete Account</v-btn>
              <v-btn color="success" @click="dialog.addRole = true;">Give User Access To Role</v-btn>
            </div>
            <div class="acc--view-grid">
              <div>
                <p class="acc--view-detail-title">USER ID #</p>
                <p class="acc--view-detail-subtitle">{{user.id}}</p>
              </div>
              <div>
                <p class="acc--view-detail-title">USER NAME</p>
                <p class="acc--view-detail-subtitle">{{user.name}}</p>
              </div>
              <div>
                <p class="acc--view-detail-title">EMAIL</p>
                <p class="acc--view-detail-subtitle">{{user.email}}</p>
              </div>
              <div>
                <p class="acc--view-detail-title">PHONE</p>
                <p class="acc--view-detail-subtitle">{{user.phone || "NOT FOUND."}}</p>
              </div>
              <div>
                <p class="acc--view-detail-title">COMPANY</p>
                <p class="acc--view-detail-subtitle" style="text-transform: capitalize;">
                  <a :href="`/company/${user.company.id}`" v-if="user.company.id">
                    {{user.company.name}}
                  </a>
                  <span v-else>{{user.company.name || "NOT FOUND."}}</span>
                </p>
              </div>
            </div>
          </v-card>
        </v-flex>
        <v-flex sm12 md12 lg6>
          <v-card class="acc--view-card" style="overflow-y: scroll; max-height: 220px;">
            <p class="acc--view-title">Roles</p>
            <div>
              <v-list style="background: inherit;">
                <v-list-tile
                  v-for="(role, idx) in roles"
                  :key="role.id"
                  avatar
                  class="elevation-2"
                  style="margin-bottom: 10px;"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ idx + 1 }}.
                      {{ role.name }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <div>
                      <v-btn icon ripple style="margin-right: 5px;" @click="() => {
                        deleteRoleId = role.id;
                        dialog.deleteRole = true;
                      }">
                        <v-icon color="error">fas fa-times-circle</v-icon>
                      </v-btn>
                    </div>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </div>
          </v-card>
        </v-flex>
        <v-flex sm12 md12 lg6>
          <v-card class="acc--view-card">
            <p class="acc--view-title">ENTITIES</p>
            <h2>LATER.</h2>
            <v-spacer/>
            <!-- <div class="acc--view-grid-address">
              <div class="acc--view-grid-address-span-2">
                <p class="acc--view-detail-title">ADDRESS 1</p>
                <p class="acc--view-detail-subtitle">194 San Carlos St</p>
              </div>
              <div class="acc--view-grid-address-span-2">
                <p class="acc--view-detail-title">ADDRESS 2</p>
                <p class="acc--view-detail-subtitle">194 San Carlos St</p>
              </div>
              <div>
                <p class="acc--view-detail-title">CITY</p>
                <p class="acc--view-detail-subtitle">Southington</p>
              </div>
              <div>
                <p class="acc--view-detail-title">STATE</p>
                <p class="acc--view-detail-subtitle">Connecticut</p>
              </div>
              <div>
                <p class="acc--view-detail-title">ZIP/PIN CODE</p>
                <p class="acc--view-detail-subtitle">06489</p>
              </div>
              <div>
                <p class="acc--view-detail-title">COUNTRY</p>
                <p class="acc--view-detail-subtitle">USA</p>
              </div>
            </div> -->
          </v-card>
        </v-flex>
        <v-flex sm12 md12 lg12>
          <v-card class="acc--view-card">
            <p class="acc--view-title">EVENTS</p>
            <h2>Later Aligator.</h2>
            <!-- <div class="acc--view-detail-text">Lorem ipsum dolor, sit amet
            consectetur adipisicing elit. Et harum rerum optio corrupti libero ea omnis distinctio,
            tempore reiciendis aut iure ad quis, perferendis nam minus.
            Libero, error maxime? Ab distinctio modi illo id
            quae necessitatibus, labore placeat nesciunt! Sed incidunt,
            consequuntur aut asperiores modi sequi, saepe deserunt
            rerum magni voluptate ipsam impedit, provident nesciunt?
            Quo corrupti voluptates impedit, in asperiores quos
            perferendis nisi, maxime porro officia quis ut, animi iste amet.
            Est sint magnam quasi odio qui nesciunt aut
            ut cumque excepturi amet dicta, cum hic porro, beatae ratione
            quod a exercitationem eos in rerum tempore minus
            inventore. Perspiciatis, aliquam quaerat animi sequi provident cum.
            Modi voluptatibus architecto tempora sunt.
            Perferendis doloribus voluptatum accusantium natus laboriosam.
            Nihil, assumenda quod deleniti distinctio qui
            repellendus. Et recusandae ipsam quibusdam asperiores perspiciatis pariatur!
            Doloremque illo modi sit optio
            ratione labore exercitationem expedita deleniti quod rerum,
            at dolorum a obcaecati dolore in earum, quis unde!
            Commodi quos distinctio officiis ipsum perspiciatis amet, ut atque,
            voluptatem aut qui, molestiae reiciendis.
            </div> -->
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container v-if="error">
      <div>
        <v-alert
          :value="error"
          type="error"
        >
          {{ error.graphQLErrors.length > 0 ? error.graphQLErrors[0].message : error.message }}
        </v-alert>
      </div>

      <v-flex sm12 md12 lg12>
        <v-card class="acc--view-card" style="min-height:150px;">
          <h2 style="text-align: center;">
            {{ error.graphQLErrors.length > 0 ? error.graphQLErrors[0].data.message : error.message }}
          </h2>

          <div style="text-align: center;">
            <v-btn color="primary" to="/user-accounts">Go back</v-btn>
          </div>
        </v-card>
      </v-flex>
    </v-container>
  </section>
</template>
<script>
import { coreClient } from "../../apollo";
import gql from "graphql-tag";
export default {
  data() {
    return {
      user: {
        id: "",
        name: "",
        email: "",
        avatar: "",
        phone: "",
        company: {}
      },
      deleteRoleId: "",
      dialog: {
        delete: false,
        deleteRole: false,
        update: false,
        loading: false,
        hasLoaded: false,
        addRole: false
      },
      snackbar: {
        show: false,
        text: "",
        color: ""
      },
      error: "",
      userNameRules: [
        v => !!v || "The name is required",
        v => (v || "").length > 2 || "The name must be atleast 2 characters."
      ],
      emailRules: [
        v => !!v || "The email is required.",
        v =>
          /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
            v
          ) || "Please enter a valid email address."
      ],
      companyRules: [v => !!v || "The company is required."],
      roleRules: [v => !!v || "The role is required."],
      form: {
        name: "",
        email: "",
        phone: "",
        company: {}
      },
      companies: [],
      valid: false,
      search: null,
      autocompleteLoading: false,
      roles: [],
      allRoles: [],
      giveRoles: [],
      search_role: null
    };
  },
  methods: {
    moveTo(uri) {
      this.$router.push(uri);
      this.$router.go();
    },
    async deleteRole(roleId) {
      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation removeUserAccessFromRoles(
              $userId: String!
              $roles: [String!]!
            ) {
              removeUserAccessFromRoles(userId: $userId, roles: $roles)
            }
          `,
          variables: {
            userId: this.user.id,
            roles: [roleId]
          }
        });

        await this.getRoles(this.user.id);

        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text: "Successfuly Revoked the user's role.",
          color: "success"
        };
      } catch (e) {
        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text: "We failed to revoke user's access from the role.",
          color: "error"
        };
      }
      this.dialog.addRole = false;
    },
    async getRoles(userId) {
      try {
        const { data } = await coreClient.query({
          query: gql`
            query UserRoles($userId: String!) {
              UserRoles(userId: $userId) {
                id
                name
              }
            }
          `,
          variables: {
            userId
          },
          fetchPolicy: "no-cache"
        });

        this.roles = data.UserRoles;
      } catch (e) {
        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text: "We failed to find the User's Roles.",
          color: "error"
        };
        this.error = e;
      }
    },
    async getUser(id) {
      this.dialog.loading = true;

      let user;
      try {
        const { data } = await coreClient.query({
          query: gql`
            query User($id: String!) {
              User(id: $id) {
                id
                name
                email
                avatar
                phone
                company {
                  id
                  name
                  logo
                  address
                  phone
                }
              }
            }
          `,
          variables: {
            id
          },
          fetchPolicy: "no-cache"
        });

        user = data.User;
      } catch (e) {
        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text: "We failed to find the User.",
          color: "error"
        };
        this.error = e;
      }
      this.dialog.loading = false;
      this.dialog.hasLoaded = true;

      if (user) {
        return user;
      }
      return null;
    },
    async updateUser() {
      let userForm = { ...this.form };
      let user = { ...this.user };
      delete userForm.company;
      delete user.company;

      let variables = {};
      Object.keys(userForm).forEach(field => {
        if (user[field] !== userForm[field]) {
          variables[field] = userForm[field];
        }
      });

      if (this.user.company.id != this.form.company.id) {
        variables["company"] = this.form.company.id;
      }

      variables.id = user.id;

      // make a query.

      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation updateUser(
              $id: String!
              $name: String
              $email: String
              $company: String
              $phone: String
            ) {
              updateUser(
                id: $id
                name: $name
                email: $email
                company: $company
                phone: $phone
              ) {
                id
                name
                email
                avatar
                phone
                company {
                  id
                  name
                  logo
                  address
                  phone
                }
              }
            }
          `,
          variables
        });

        this.user = data.updateUser;
        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text: "The User has been updated successfully.",
          color: "success"
        };
      } catch (e) {
        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text:
            e.graphQLErrors.length > 0
              ? e.graphQLErrors[0].data.message
              : e.message,
          color: "error"
        };
      }

      this.dialog.update = false;
      this.$router.push("/user-accounts/" + this.$route.params.id);
    },
    async deleteUser() {
      this.dialog.loading = true;
      try {
      } catch (e) {}
      this.dialog.loading = false;
    },
    async getCompanies(variables = {}) {
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Companies($name: String, $limit: Int) {
              Companies(name: $name, limit: $limit) {
                docs {
                  id
                  name
                  logo
                  address
                  phone
                }
              }
            }
          `,
          variables: { ...variables, limit: 20 }
        });

        this.companies = data.Companies.docs.map(doc => {
          return { ...doc, text: doc.name };
        });
      } catch (e) {
        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text:
            e.graphQLErrors.length > 0
              ? e.graphQLErrors[0].data.message
              : e.message,
          color: "error"
        };
      }
    },
    async getAllRoles(variables = {}) {
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Roles($name: String, $limit: Int) {
              Roles(name: $name, limit: $limit) {
                total
                pages
                page
                docs {
                  id
                  name
                }
              }
            }
          `,
          variables: { ...variables, limit: 20 }
        });

        this.allRoles = data.Roles.docs;
      } catch (e) {
        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text: "We failed to search the Roles.",
          color: "error"
        };
        this.error = e;
      }
    },
    async giveUserAccessToRole() {
      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation giveUserAccessToRoles(
              $userId: String!
              $roles: [String!]!
            ) {
              giveUserAccessToRoles(userId: $userId, roles: $roles)
            }
          `,
          variables: {
            userId: this.user.id,
            roles: this.giveRoles.map(role => role.id)
          }
        });

        await this.getRoles(this.user.id);
        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text: "Successfuly gave User the role.",
          color: "success"
        };
      } catch (e) {
        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text: "We failed to give user access to roles.",
          color: "error"
        };
      }
      this.dialog.addRole = false;
    }
  },
  watch: {
    async "dialog.addRole"(v) {
      if (v) {
        await this.getAllRoles({});
      }
    },
    async search_role(v) {
      if (!v) {
        this.giveRoles = [];
        await this.getAllRoles();
        return;
      }

      this.autocompleteLoading = true;
      v && v !== this.giveRoles && (await this.getAllRoles({ name: v }));
      this.autocompleteLoading = false;
    },
    async search(v) {
      if (!v) {
        this.form.company = "";
        await this.getCompanies();
        return;
      }

      this.autocompleteLoading = true;
      v && v !== this.form.company && (await this.getCompanies({ name: v }));
      this.autocompleteLoading = false;
    }
  },
  async mounted() {
    this.user = await this.getUser(this.$route.params.id);
    await this.getRoles(this.user.id);
    if (!this.user) {
      return;
    }

    let { query } = this.$route;

    if (query.delete && query.update) {
      // Uhmm, some error probably.
      return;
    }

    if (query.update) {
      // open the update prompt
      await this.getCompanies();
      this.dialog.update = true;
      this.form = {
        name: this.user.name,
        email: this.user.email,
        company: {
          ...this.user.company,
          text: this.user.company.name
        },
        phone: this.user.phone
      };
      return;
    }

    if (query.delete) {
      // open the delete prompt
      this.dialog.delete = true;
      return;
    }

    return;
  }
};
</script>
<style lang="stylus" scoped>
@import '../../assets/stylus/UserAccounts_view.styl';

#user-avatar {
  padding: 7.5em 0;
  margin: 0 auto;
}
</style>
